import { customFetch } from '../../../shared/customFetch';
import { API_ROUTES } from '../../shared/ApiRoutes';

export const signIn = (email: string, password: string) => {
  return customFetch.post(API_ROUTES.SIGNIN, { email, password });
};

export const verify = (email: string, code: string) => {
  return customFetch.post(API_ROUTES.VERIFY, { email, code });
};
